import React from "react";

class Loading extends React.Component{

    render(){
        return(
            <div className="row">
                <div className="col-xs-12 text-center">
                    <img src={require('assets/img/loading.gif')} className="img-fluid" style={{"height": "60px", "marginTop": "100px", "marginBottom": "100px"}}/> { this.props.children }
                </div>
          </div>
        )
    }
}

export default Loading


// WEBPACK FOOTER //
// ./src/views/etc/Loading.js